import React, { useEffect } from "react";

import { Accordion, AccordionItem } from "@nextui-org/accordion";
import { useState } from "react";
import { ReactComponent as ArrowUpIcon } from "../../assets/icons/caret-double-up.svg";
import SubTicketTable from "./subTicketTable/SubTicketTable";
import TicketCard from "../Ticket/TicketCard";
import CustomTextArea from "../CustomTextArea";
import { TicketPropsInterface } from "../../models/TicketProp";
import {
  stringToTicketPhase,
  stringToTicketStatus,
  TicketPhase,
  TicketStatus,
} from "../../assets/js/AppTicketConstant";
import { Button, useDisclosure } from "@nextui-org/react";
import PrintButton from "./PrintButton";
import DealerTicketActionButton from "./DealerTicketActionButton";
import AttachClaimDocumentModal from "../AttachClaimDocumentModal";
import {
  SubmitClaimDocument,
  UpdateClaimTicket,
} from "../../services/SubmitClaimService";
import useClaimStore from "../../stores/useClaimStore";
import AppUtility from "../../assets/js/AppUtility";
import useTicketStore from "../../stores/useTicketStore";
import EditTicketModal, { NoteType } from "../EditTicketModal";
import useSubTicketStore from "../../stores/useSubTicketStore";
import { UpdateProposalTicket } from "../../services/TicketService";
import ConfirmApproveModal from "../ConfirmApproveModal";
import { UpdateManagementTicket } from "../../services/SubmitManagementReviewService";
import { CancelAllTicket } from "../../services/TicketService";
import PropTypes from "prop-types";
import TargetTable from "../Ticket/TargetTable";
import dayjs from "dayjs";

const DealerTicketTile = ({ ticketData, reFetch }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState(new Set([]));

  const [isTicketV2, setIsTicketV2] = useState(false);

  const { setClaimData } = useClaimStore();

  const {
    isOpen: isAttachDocumentModalOpen,
    onOpenChange: onAttachDocumentModalOpenChange,
  } = useDisclosure();

  const {
    isOpen: isEditSubTicketModalOpen,
    onOpenChange: onEditSubTicketModalOpenChange,
  } = useDisclosure();

  const {
    isOpen: isConfirmEditModalOpen,
    onOpenChange: onConfirmEditModalOpenChange,
  } = useDisclosure();

  const {
    isOpen: isConfirmCancelModalOpen,
    onOpenChange: onConfirmCancelModalOpenChange,
  } = useDisclosure();

  const [selectSubTicket, setSelectSubTicket] = useState([]);

  const { areReadyToSubmit } = useClaimStore();
  const { fetchTicketById, getTicketDetailById } = useTicketStore();
  const [currentTicketDetail, setCurrentTicketDetail] = useState();
  const {
    setRejectSubTickets,
    areAllRejectedTicketsSelected,
    getRejectTicket,
  } = useSubTicketStore();

  const [carInfos, setCarInfos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inputCarInfos, setInputCarInfos] = useState([]);

  const [readyToSubmitClaim, setReadyToSubmitClaim] = useState(null);

  useEffect(() => {
    if (carInfos.length > 0) {
      setIsExpanded(true);
    }
  }, [carInfos]);

  useEffect(()=> {
    setIsTicketV2(dayjs(ticketData.created_at) > dayjs("2025-08-31"));
  }, [ticketData])

  const handleCollapse = () => {
    setSelectedKeys(new Set([]));
    setIsExpanded(false);
  };

  const getTotalAmount = ({ ticketId }) => {
    const subTicket = ticketData.sub_tickets.find(
      (subTicket) => subTicket.id === ticketId
    );
    switch (stringToTicketPhase(ticketData.phase)) {
      case TicketPhase.Claim:
      case TicketPhase.Management:
      case TicketPhase.Accounting:
        return subTicket.claim_amount;
      default:
        return subTicket.proposal_amount;
    }
  };

  const handleRecordClaimDoc = ({ claimData }) => {
    const subTicketClaim = ticketData.sub_tickets
      .filter((item) =>
        selectSubTicket.find((selected) => selected.id === item.id)
      )
      .map((item) => {
        return {
          id: item.id,
          claim_amount: claimData.claim_amount,
          claim_file_urls: claimData.select_file_urls.map(
            (fileMap) => Array.from(fileMap.values())[0]
          ),
        };
      });

    const claimDoc = {
      sub_tickets: subTicketClaim[0],
    };
    setClaimData({ id: Number(subTicketClaim[0]?.id), data: claimDoc });
    onAttachDocumentModalOpenChange();
    setSelectSubTicket([]);
  };

  const extractSubTickets = (dataArray) => {
    const subTickets = dataArray.map((obj) => {
      const data = Object.values(obj)[0];
      return data.sub_tickets;
    });

    return {
      sub_tickets: subTickets,
    };
  };

  const handleSubmitClaimDoc = async () => {
    const checkAllRecord = ticketData.sub_tickets.every((subTicket) => {
      return useClaimStore
        .getState()
        .claimData.some((store) => subTicket.id in store);
    });

    if (checkAllRecord) {
      const matchingRecord = ticketData.sub_tickets.map((subTicket) =>
        useClaimStore.getState().claimData.find((obj) => subTicket.id in obj)
      );

      const ticketCarInfosPayload = inputCarInfos.map((rawData) => ({
        id: rawData.id,
        actual_customer_amount: Number(rawData.actualCustomerAmount),
        actual_reserved_amount: Number(rawData.actualReservedAmount),
      }));

      const bodyPayload = {
        ticket_car_infos: ticketCarInfosPayload,
        sub_tickets: extractSubTickets(matchingRecord).sub_tickets,
      };

      await SubmitClaimDocument({
        ticketId: ticketData.id,
        bodyPayload: bodyPayload,
        isTicketV2: isTicketV2,
      });
    }

    setSelectSubTicket([]);
  };

  const findSubTicketById = (data) => {
    return ticketData.sub_tickets.find((item) => data.id.data === item.id);
  };

  const handleOnEditTicket = (subTicket) => {
    const ticketDetail = getTicketDetailById(ticketData.id);

    const currentSubTicket = ticketDetail.sub_tickets.find(
      (subTicketArray) => subTicketArray.id === subTicket.id
    );

    setCurrentTicketDetail(currentSubTicket);
  };

  const getInitialValue = () => {
    const editTicket = getRejectTicket(currentTicketDetail?.id);
    const initialSource = editTicket ?? currentTicketDetail;

    return {
      ticket_id: initialSource?.id,
      sub_ticket_code: initialSource?.code,
      project_name: initialSource?.name,
      amount:
        stringToTicketPhase(ticketData.phase) === TicketPhase.Proposal
          ? initialSource?.proposal_amount
          : initialSource?.claim_amount,
      description: initialSource?.description,
      attachment_file_urls:
        stringToTicketPhase(ticketData.phase) === TicketPhase.Proposal
          ? initialSource?.proposal_file_urls
          : initialSource?.claim_file_urls,
    };
  };

  const submitUpdateProposal = async () => {
    const allRejectTicket = useSubTicketStore.getState().rejectSubTickets;
    const targetSubTicket = Object.values(allRejectTicket).filter((obj) =>
      ticketData.sub_tickets.some((subTicket) => subTicket.id === obj.id)
    );

    await UpdateProposalTicket({
      ticketId: ticketData.id,
      bodyPayload: {
        ticket: ticketData,
        to_update_sub_tickets: targetSubTicket,
      },
    });
  };

  const submitUpdateClaim = async () => {
    const allRejectTicket = useSubTicketStore.getState().rejectSubTickets;
    const targetSubTicket = Object.values(allRejectTicket).filter((obj) =>
      ticketData.sub_tickets.some((subTicket) => subTicket.id === obj.id)
    );

    await UpdateClaimTicket({
      ticketId: ticketData.id,
      bodyPayload: {
        ticket: ticketData,
        sub_tickets: targetSubTicket,
      },
    });
  };

  const submitUpdateManagement = async () => {
    const allRejectTicket = useSubTicketStore.getState().rejectSubTickets;
    const targetSubTicket = Object.values(allRejectTicket).filter((obj) =>
      ticketData.sub_tickets.some((subTicket) => subTicket.id === obj.id)
    );

    await UpdateManagementTicket({
      ticketId: ticketData.id,
      bodyPayload: {
        sub_tickets: targetSubTicket,
      },
    });
  };

  const submitSubTicketAction = () => {
    if (ticketData.phase === null && ticketData.status === null) return null;

    const phase = stringToTicketPhase(ticketData.phase);
    const status = stringToTicketStatus(ticketData.status);

    const buttonConfig = {
      [`${TicketPhase.Proposal.value}_${TicketStatus.Approved.value}`]: {
        text: "ยืนยันการส่งหลักฐานการจ่ายเงินทั้งหมด",
        action: () => {
          setReadyToSubmitClaim(validateInputCarInfo());
          if (readyToSubmitClaim) onConfirmEditModalOpenChange();
        },
        getIsDisabled: () => areReadyToSubmit(ticketData.sub_tickets),
        bgColor: "bg-warning",
      },
      [`${TicketPhase.Proposal.value}_${TicketStatus.Rejected.value}`]: {
        text: "ยืนยันการแก้ไข",
        action: onConfirmEditModalOpenChange,
        getIsDisabled: () =>
          areAllRejectedTicketsSelected(
            ticketData.sub_tickets.filter(
              (subTicket) =>
                stringToTicketStatus(subTicket.status) === TicketStatus.Rejected
            )
          ),
      },
      [`${TicketPhase.Claim.value}_${TicketStatus.Rejected.value}`]: {
        text: "ยืนยันการแก้ไข",
        action: onConfirmEditModalOpenChange,
        getIsDisabled: () =>
          areAllRejectedTicketsSelected(
            ticketData.sub_tickets.filter(
              (subTicket) =>
                stringToTicketStatus(subTicket.status) === TicketStatus.Rejected
            )
          ),
      },
      [`${TicketPhase.Management.value}_${TicketStatus.Rejected.value}`]: {
        text: "ยืนยันการแก้ไข",
        action: onConfirmEditModalOpenChange,
        getIsDisabled: () =>
          areAllRejectedTicketsSelected(
            ticketData.sub_tickets.filter(
              (subTicket) =>
                stringToTicketStatus(subTicket.status) === TicketStatus.Rejected
            )
          ),
      },
    };

    const key = `${phase.value}_${status.value}`;
    const config = buttonConfig[key];

    if (!config) return null;

    const { text, action, getIsDisabled, bgColor } = config;

    return (
      <Button
        className={`w-full mt-4 ${bgColor ?? "bg-blue-500"} text-white`}
        onPress={action}
        isDisabled={!getIsDisabled()}
      >
        {text}
      </Button>
    );
  };

  const renderConfirmSubimtTicketModal = () => {
    if (ticketData.phase === null && ticketData.status === null) return null;

    const phase = stringToTicketPhase(ticketData.phase);
    const status = stringToTicketStatus(ticketData.status);

    const confirmModalConfig = {
      [`${TicketPhase.Proposal.value}_${TicketStatus.Rejected.value}`]: {
        title: "ยืนยันการแก้ไข",
        onConfirm: async () => {
          await submitUpdateProposal();
        },
        isOpen: isConfirmEditModalOpen,
        onOpenChange: onConfirmEditModalOpenChange,
      },
      [`${TicketPhase.Proposal.value}_${TicketStatus.Approved.value}`]: {
        title: "ยืนยันการส่งหลักฐานการจ่ายเงินทั้งหมด",
        onConfirm: async () => {
          await handleSubmitClaimDoc();
        },
        isOpen: isConfirmEditModalOpen,
        onOpenChange: onConfirmEditModalOpenChange,
      },
      [`${TicketPhase.Claim.value}_${TicketStatus.Rejected.value}`]: {
        title: "ยืนยันการแก้ไขหลักฐาน",
        onConfirm: async () => {
          await submitUpdateClaim();
        },
        isOpen: isConfirmEditModalOpen,
        onOpenChange: onConfirmEditModalOpenChange,
      },
      [`${TicketPhase.Management.value}_${TicketStatus.Rejected.value}`]: {
        title: "ยืนยันการแก้ไขหลักฐาน",
        onConfirm: async () => {
          await submitUpdateManagement();
        },
        isOpen: isConfirmEditModalOpen,
        onOpenChange: onConfirmEditModalOpenChange,
      },
    };

    const key = `${phase.value}_${status.value}`;
    const config = confirmModalConfig[key];

    if (!config) return null;

    return (
      <ConfirmApproveModal
        {...config}
        onConfirm={async () => {
          try {
            await config.onConfirm();
            AppUtility.refreshPage();
          } catch (e) {
            void e;
          }
        }}
      />
    );
  };

  const isDisableInputActual = () => {
    const status = stringToTicketStatus(ticketData.status);
    const phase = stringToTicketPhase(ticketData.phase);

    return !(
      status === TicketStatus.Approved && phase === TicketPhase.Proposal
    );
  };

  const validateInputCarInfo = () => {
    const defaultCarInfo = carInfos;
    const isAllModelsIncluded = defaultCarInfo.every((car) => {
      return inputCarInfos.some((inputCar) => inputCar.name === car.name);
    });

    const hasValidAmount = inputCarInfos.every(
      (car) =>
        car.actualCustomerAmount !== null &&
        car.actualReservedAmount !== null &&
        car.actualCustomerAmount >= 0 &&
        car.actualReservedAmount >= 0
    );

    return hasValidAmount && isAllModelsIncluded;
  };

  return (
    <>
      <Accordion
        selectedKeys={selectedKeys}
        onSelectionChange={async (keys) => {
          setSelectedKeys(keys);
          setIsExpanded(keys.size === 1);
          if (keys.size === 1) {
            setIsLoading(true);
            await fetchTicketById(ticketData.id);
            const ticketDetail = getTicketDetailById(ticketData.id);
            if (ticketDetail?.ticket_car_infos?.length > 0) {
              const initialCarInfo = ticketDetail.ticket_car_infos.map(
                (info) => ({
                  id: info.id,
                  name: info.car_model_name,
                  expectedCustomerAmount: info.expected_customer_amount,
                  expectedReservedAmount: info.expected_reserved_amount,
                  actualCustomerAmount: info.actual_customer_amount,
                  actualReservedAmount: info.actual_reserved_amount,
                })
              );

              setCarInfos(initialCarInfo);
            } else {
              setCarInfos([]);
            }
            setIsLoading(false);
          }
        }}
        variant="spiltted"
      >
        <AccordionItem
          title={<TicketCard isExpanded={isExpanded} ticketData={ticketData} />}
          textValue={" "}
          classNames={{
            title: "p-4 bg-white text-black font-bold w-full",
            content: "bg-white px-5 rounded-b-3xl",
            base: "border-none",
            trigger: `bg-white flex justify-between p-3 lg:p-5  overflow-hidden ${
              isExpanded ? "rounded-t-3xl" : "rounded-3xl"
            }`,
          }}
          indicator={() => <></>}
        >
          <div className="px-4">
            <div className="pb-4 border-gray-300 border-t-1" />
            <div className="flex flex-col gap-y-2 pb-4">
              <p className="font-semibold">รายละเอียด</p>
              <CustomTextArea isDisabled value={ticketData.description} />
            </div>
            {!isLoading && (
              <div className="pb-10">
                <div
                  className={`${
                    readyToSubmitClaim == false &&
                    "border-red-500 border-2 rounded-2xl p-3"
                  } `}
                >
                  <TargetTable
                    isEditable
                    isDisableInput={isDisableInputActual()}
                    initialData={carInfos}
                    submitData={(data) => {
                      setInputCarInfos(data);
                      setReadyToSubmitClaim(validateInputCarInfo());
                    }}
                  />
                </div>
                {readyToSubmitClaim == false && (
                  <p className="text-red-500 text-center pt-3">
                    กรุณากรอกจำนวน
                  </p>
                )}
              </div>
            )}
            <div className="p-2 lg:p-4 bg-light-gray-600 rounded-3xl overflow-x-auto">
              <SubTicketTable
                id={ticketData.id}
                ticketPhase={stringToTicketPhase(ticketData.phase)}
                ticketStatus={stringToTicketStatus(ticketData.status)}
                ticketSequenceApproved={{
                  last_approver_sequence_no:
                    ticketData.last_approver_sequence_no,
                  next_approver_level: ticketData.next_approver_level,
                  next_approver_sequence_no:
                    ticketData.next_approver_sequence_no,
                  next_approver_user_id: ticketData.next_approver_user_id,
                }}
                columns={[
                  {
                    name: "สถานะ",
                    key: "status",
                  },
                  {
                    name: "เลขที่คำขอ",
                    key: "code",
                  },
                  {
                    name: "ชื่อค่าใช้จ่าย",
                    key: "name",
                  },
                  {
                    name: (
                      <div className="leading-relaxed">
                        งบขอจัดกิจกรรม
                        <br />
                        จำนวนเงินก่อน VAT
                      </div>
                    ),
                    key: "proposal_amount",
                  },
                  ...(stringToTicketPhase(ticketData.phase) !==
                  TicketPhase.Proposal
                    ? [
                        {
                          name: (
                            <div className="leading-relaxed">
                              งบขอเบิกจ่าย
                              <br />
                              จำนวนเงินก่อน VAT
                            </div>
                          ),
                          key: "claim_amount",
                        },
                      ]
                    : []),
                  {
                    name: "รายละเอียด",
                    key: "description",
                  },
                  {
                    name: "ไฟล์คำขออนุมัติ",
                    key: "proposal_file_urls",
                  },
                  ...(stringToTicketPhase(ticketData.phase) !==
                  TicketPhase.Proposal
                    ? [
                        {
                          name: "ไฟล์คำขอทำจ่าย",
                          key: "claim_file_urls",
                        },
                      ]
                    : []),
                  {
                    name: "Action",
                    key: "action",
                  },
                ]}
                data={ticketData.sub_tickets.map((subTicket) => {
                  const baseValue = {
                    id: {
                      data: subTicket.id,
                    },
                    status: {
                      data: subTicket.status,
                      className: "w-[5%] ",
                    },
                    code: {
                      data: `# ${subTicket.code}`,
                      className: "w-[5%] text-nowrap",
                    },
                    name: {
                      data: subTicket.name,
                      className: "w-[10%] text-nowrap",
                    },
                    proposal_amount: {
                      data: subTicket.proposal_amount,
                      className: "w-[5%] ",
                    },

                    description: {
                      data: subTicket.description,
                      className: "w-[30%] text-nowrap",
                    },
                    proposal_file_urls: {
                      data: subTicket.proposal_file_urls,
                      className: "w-[30%] ",
                    },
                    total_amount: {
                      data: getTotalAmount({ ticketId: subTicket.id }),
                      className: "w-[5%] ",
                    },
                    action: {
                      data: subTicket.status,
                    },
                  };

                  if (
                    stringToTicketPhase(ticketData.phase) !==
                    TicketPhase.Proposal
                  ) {
                    baseValue.claim_file_urls = {
                      data: subTicket.claim_file_urls || [],
                      className: "w-[30%] ",
                    };
                    baseValue.claim_amount = {
                      data: subTicket.claim_amount || 0,
                      className: "w-[5%]",
                    };
                  }

                  return {
                    value: baseValue,
                    key: subTicket.id,
                  };
                })}
                actions={(() => {
                  switch (stringToTicketPhase(ticketData.phase)) {
                    case TicketPhase.Proposal:
                      return {
                        editable: {
                          onPress: (data) => {
                            const targetSubTicket = findSubTicketById(data);
                            handleOnEditTicket(targetSubTicket);
                            setSelectSubTicket([
                              targetSubTicket,
                              ...selectSubTicket,
                            ]);
                            onEditSubTicketModalOpenChange();
                          },
                        },
                        submitPaymentProof: {
                          onPress: (data) => {
                            const targetSubTicket = findSubTicketById(data);
                            onAttachDocumentModalOpenChange();
                            setSelectSubTicket([
                              targetSubTicket,
                              ...selectSubTicket,
                            ]);
                          },
                        },
                      };
                    case TicketPhase.Claim:
                      return {
                        editable: {
                          onPress: (data) => {
                            const targetSubTicket = findSubTicketById(data);
                            handleOnEditTicket(targetSubTicket);
                            setSelectSubTicket([
                              targetSubTicket,
                              ...selectSubTicket,
                            ]);
                            onEditSubTicketModalOpenChange();
                          },
                        },
                        submitPaymentProof: {
                          onPress: (data) => {
                            onAttachDocumentModalOpenChange();
                            const targetSubTicket = findSubTicketById(data);
                            setSelectSubTicket([
                              targetSubTicket,
                              ...selectSubTicket,
                            ]);
                          },
                        },
                      };
                    case TicketPhase.Management:
                      return {
                        editable: {
                          onPress: (data) => {
                            const targetSubTicket = findSubTicketById(data);
                            handleOnEditTicket(targetSubTicket);
                            setSelectSubTicket([
                              targetSubTicket,
                              ...selectSubTicket,
                            ]);
                            onEditSubTicketModalOpenChange();
                          },
                        },
                      };
                    default:
                      return null;
                  }
                })()}
              />
              {submitSubTicketAction()}
            </div>

            <div className="grid lg:grid-cols-3 py-5 w-full gap-4">
              <div className="flex justify-center lg:justify-start">
                <PrintButton />
              </div>
              <div className="flex justify-center">
                <Button
                  className="flex justify-center bg-white hover:bg-gray-50 transition-colors"
                  isIconOnly
                  onPress={() => {
                    handleCollapse();
                  }}
                >
                  <ArrowUpIcon className="p-2" />
                </Button>
              </div>
              <div className="flex justify-center lg:justify-end">
                {DealerTicketActionButton({
                  ticketPhase: ticketData.phase,
                  ticketStatus: ticketData.status,
                  onCancelTicket: () => {
                    onConfirmCancelModalOpenChange();
                  },
                })}
              </div>
            </div>
          </div>
        </AccordionItem>
      </Accordion>
      <AttachClaimDocumentModal
        isOpen={isAttachDocumentModalOpen}
        onOpenChange={onAttachDocumentModalOpenChange}
        onConfirm={(claimData) => {
          handleRecordClaimDoc({ claimData: claimData });
        }}
        currentSubTicket={selectSubTicket != null ? selectSubTicket[0] : null}
      />

      <ConfirmApproveModal
        headerColor={"bg-error"}
        isOpen={isConfirmCancelModalOpen}
        title={`ยืนยันการยกเลิกคำขอ`}
        confirmColor={"bg-error"}
        onOpenChange={onConfirmCancelModalOpenChange}
        onConfirm={async () => {
          await CancelAllTicket(ticketData.id);
          reFetch();
        }}
      />
      <EditTicketModal
        isOpen={isEditSubTicketModalOpen}
        onOpenChange={onEditSubTicketModalOpenChange}
        note={{
          noteType: NoteType.Rejected,
          note: {
            subTicketDetail: currentTicketDetail,
            subTicketReview: currentTicketDetail?.reviews.slice(-1)[0],
          },
        }}
        initialValue={getInitialValue()}
        onConfirm={(data) => {
          const ticketDetail = getTicketDetailById(ticketData.id);
          let targetSubTicket = ticketDetail.sub_tickets.find(
            (subTicket) => subTicket.code == data.sub_ticket_code
          );

          const fileUrlKey =
            stringToTicketPhase(ticketData.phase) === TicketPhase.Proposal
              ? "proposal_file_urls"
              : "claim_file_urls";
          const editAmount =
            stringToTicketPhase(ticketData.phase) === TicketPhase.Proposal
              ? "proposal_amount"
              : "claim_amount";

          targetSubTicket = {
            ...targetSubTicket,
            description: data.description,
            [editAmount]: Number(data.amount),
            [fileUrlKey]: data.attachment_file_urls,
          };
          setRejectSubTickets({
            subTicketId: targetSubTicket.id,
            data: targetSubTicket,
          });
        }}
      />
      {renderConfirmSubimtTicketModal()}
    </>
  );
};

DealerTicketTile.propTypes = {
  ticketData: TicketPropsInterface,
  reFetch: PropTypes.func,
};

export default DealerTicketTile;
